import React from "react";
/* asset imports */
import fatCart1 from "../assets/images/fats/fats-1.png";
import fatCart2 from "../assets/images/fats/fats-2.png";
import fatCart3 from "../assets/images/fats/fats-3.png";
import MainCartModal from "./modals/MainCartModal";

const HealthyFatsCartLarge = ({
  handleCartClick,
  handleCartItemClick,
  activeCartData,
}) => {
  return (
    <>
      <div className="carts-main-wrapper">
        <div className="close-icon" onClick={() => handleCartClick(0)}>
          <span className="material-symbols-rounded">close</span>
        </div>
        <div className="cart-large fats-cart-empty">
          <img
            src={fatCart1}
            alt=""
            className="inner-img-var-1-1"
            onClick={() => handleCartItemClick("milk-based-fats")}
          />
          <img
            src={fatCart2}
            alt=""
            className="inner-img-var-1-2"
            onClick={() => handleCartItemClick("monounsaturated-fats")}
          />
          <img
            src={fatCart3}
            alt=""
            className="inner-img-var-1-3"
            onClick={() => handleCartItemClick("polyunsaturated-fats")}
          />
        </div>
      </div>
      <MainCartModal activeCartData={activeCartData} />
    </>
  );
};

export default HealthyFatsCartLarge;
